import { useQuery } from '@apollo/client';
import { Box } from '@mui/material';
import Loader from 'Components/Forms/Loader';
import { PRODUCT_TABS, EProductTabKey } from 'FeatureModules/ProductPage/Pages/ProductOverview';
import { Tabs } from 'DesignSystem';
import { GET_PRODUCT } from 'graphql/secure/queries';
import React, { FC, PropsWithChildren } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import ErrorState from 'Components/ErrorState';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';
import { IBaseProduct } from 'FeatureModules/ProductPage/types/product.types';

const AnalyticsLayout: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { data, loading, error } = useQuery<{ product?: IBaseProduct }>(GET_PRODUCT, {
    variables: { id },
    fetchPolicy: 'cache-only',
  });

  const onChange = (tab: EProductTabKey) => {
    if (tab === EProductTabKey.OVERVIEW) {
      navigate(`/products/active/${id}`);
    } else {
      navigate(`/products/active/${id}/${tab}`);
    }
  };

  if (loading) {
    return <Loader />;
  }
  if (error || !data) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <PageTitle
        title="Product analytics"
        titleExtension={data.product?.title}
        goBackLabel="Product pages"
        goBackUrl="/products/active"
      />
      <Box mt={3} mb={2}>
        <Tabs tabs={PRODUCT_TABS} selectedTab={EProductTabKey.ANALYTICS} onChange={onChange} />
      </Box>
      <Box mt={2} height="100%">
        <Outlet />
      </Box>
    </PageContainer>
  );
};

export default AnalyticsLayout;
